import React, { MouseEvent } from 'react';
import { Link, SxProps, Theme } from '@mui/material';
import { useSelector } from 'react-redux';

import { getBranding } from '../../store/branding/branding.selectors';
import { BrandingFields } from '../../types/Branding.types';

const styles: { [className: string]: SxProps<Theme> } = {
  link: {
    display: 'inline-block',
    color: 'customStyling.highlightColor',
    fontWeight: 'bold',
    '&:hover': {
      textDecoration: 'none',
    },
  },
} as const;

export interface ISupportLinkProps {
  text?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement> & MouseEvent<HTMLSpanElement>) => void;
}

const SupportLink = ({ text = 'Contact support', onClick }: ISupportLinkProps): JSX.Element => {
  const customStyling = useSelector(getBranding);

  return (
    <Link
      sx={styles.link}
      href={customStyling[BrandingFields.contactSupportLink]}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      onClick={onClick}
    >
      {text}
    </Link>
  );
};

export default SupportLink;
